interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export default function SectionHeading({ eyebrow, title, description, align = 'center', className = '' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`${isCenter ? 'text-center mx-auto' : 'text-left'} max-w-2xl mb-10 md:mb-14 ${className}`}>
      {eyebrow && (
        <div className={`flex items-center gap-2 mb-3 ${isCenter ? 'justify-center' : ''}`}>
          <span className="w-6 h-px bg-primary-500"></span>
          <span className="text-sm font-medium tracking-wide text-primary-600">{eyebrow}</span>
          <span className="w-6 h-px bg-primary-500"></span>
        </div>
      )}
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug text-balance">{title}</h2>
      {description && <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{description}</p>}
    </div>
  );
}